<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground" short-title="Swiss" title="Swiss" :logo="logo">
      <template slot="links">
        <li v-if="shops && shops.length >= 1" class="nav-item select">
          <base-input placeholder="order base" class="mb-0">
            <select
                    name="shop"
                    :class="{'custom-select': true}"
                    v-model="selectedShop"
                    @change="updateShop"
                    :disabled="shops.length === 1"
            >
              <option v-for="shop in shops" :key="shop.site_id" :value="shop.site_id" :data-site-name="shop.name">{{shop.name}}</option>
            </select>
          </base-input>
        </li>

        <li v-else class="nav-item select" v-t="'main.login.no_sites'"></li>

        <sidebar-item
                :link="{
            name: this.$t('routes.dashboard'),
            icon: 'ni ni-tv-2 text-primary',
            path: '/dashboard'
          }"
        />

        <li class="accordion nav-item" id="nav">
          <template v-for="module in menu">
            <span
                    class="nav-group nav-link"
                    :id="`heading-${module.module_name.replace(' ', '-')}`"
                    @click="toggleNavGroup(module.module_name.replace(' ', '-'))"
                    :key="module.module_name.replace(' ', '-')"
            >
              <!-- <i class="ni ni-book-bookmark text-orange"></i> -->
              <i class="fas fa-bars text-default"></i>
              <span class="nav-link-text">{{module.module_name}}</span>
            </span>

            <div
                    v-for="path in module.paths"
                    :id="`collapse-${module.module_name.replace(' ', '-')}`"
                    :class="{
                  collapse: false,
                  show: selected.indexOf(`collapse-${module.module_name.replace(' ', '-')}`) !== -1,
                  'nav-padding': true
                  }"
                    :key="path.path_url"
            >
              <sidebar-item
                      :link="{name: path.path_name, icon: 'fas fa-angle-right text-primary', path: path.path_url}"
              />
            </div>
          </template>
        </li>

        <template v-if="isDev">
          <sidebar-item :link="{name: 'Login', icon: 'ni ni-key-25 text-info', path: '/login'}" />
        </template>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <base-header class="pb-6 pb-8 pt-5 pt-md-6 pt-xl-8 bg-sm-accent"></base-header>
        <fade-transition :duration="100" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view :key="$route.path"></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>

        <modal :show.sync="showIdleModal">
          <h6 slot="header" class="modal-title" id="modal-title-default"></h6>
          <p v-t="'main.messages.idle_notice'"></p>
          <countdown ref="logoutCountdown" :time="logoutCountdownTime" :auto-start="false">
            <template slot-scope="props">{{$t('main.to_logout')}} {{ props.minutes }} {{$t('main.minutes')}}, {{ props.seconds }} {{$t('main.seconds')}}.</template>
          </countdown>
          <template slot="footer">
            <base-button type="primary" @click="getToken" v-t="'main.continue'"></base-button>
            <base-button type="link" class="ml-auto" @click="onLogout" v-t="'main.logout'"></base-button>
          </template>
        </modal>

      </div>
    </div>
  </div>
</template>
<script>
    import DashboardNavbar from "./DashboardNavbar.vue";
    import ContentFooter from "./ContentFooter.vue";
    import { FadeTransition } from "vue2-transitions";
    import VueCountdown from '@chenfengyuan/vue-countdown';

    export default {
        components: {
            DashboardNavbar,
            ContentFooter,
            FadeTransition,
            countdown: VueCountdown
        },
        data() {
            return {
                logo: 'img/brand/motors-logo.jpg',
                selected: [],
                sidebarBackground: "vue", //vue|blue|orange|green|red|primary,
                isDev: null,
                selectedShop: null,
                shops: null,
                menu: null,
                showIdleModal: false,
                logoutCountdownTime: Number(process.env.VUE_APP_LOGOUT_COUNTDOWN_TIME),
                refreshTokenTimer: Number(process.env.VUE_APP_REFRESH_TOKEN_COUNTDOWN_TIME),
            };
        },
        computed: {
            menus() {
                return this.$store.state.general.user.menu;
            },
            shopsWatch() {
                return this.$store.state.general.user.shop_list;
            },
            isIdle() {
                return this.$store.state.idleVue.isIdle;
            }
        },
        watch: {
            menus: {
                handler(n) {
                    this.menu = n;
                },
                deep: true
            },
            shopsWatch: {
                handler(n) {
                    this.shops = n;
                },
                deep: true
            },
            isIdle(n) {
                if(n === true && !this.showIdleModal){
                    !this.$refs.logoutCountdown.progress() ? this.$refs.logoutCountdown.start() :
                        this.$refs.logoutCountdown.continue();

                    this.showIdleModal = true;
                    setTimeout(function(scope) {
                        scope.onLogout();
                    }, this.logoutCountdownTime, this);
                }
            },
        },
        mounted() {
            this.isDev = this.$store.state.general.env.isDev;
            this.selectedShop = this.$getData('site_id',true);

            this.shops = JSON.parse(this.$getData("shops"));
            this.menu = JSON.parse(this.$getData("menu"));

            // Request a new token at every 50 minutes
            this.setCountdown();
        },
        methods: {
            getToken() {
                const token = JSON.parse(this.$getData("token"));
                if(token) {
                    this.showIdleModal = false;
                    this.$axios.post('/auth/refresh', {token: token})
                        .then(resp=> {
                            sessionStorage.setItem('token', JSON.stringify(resp.data.token));
                            this.$axios.defaults.headers['Authorization'] = `Bearer ${resp.data.token}`;
                            this.$refs.logoutCountdown.pause();
                        })
                        .catch(err => {
                            console.log("refreshing token", err)
                        })
                } else{
                    this.$refs.logoutCountdown.end();
                    this.onLogout();
                }
            },
            setCountdown(){
                setInterval(function () {
                    this.getToken();
                }.bind(this), this.refreshTokenTimer);
            },
            onLogout() {
                // clear the countdown
                if(this.$refs.logoutCountdown){
                    this.$refs.logoutCountdown.end();
                }
                // Remove local data
                sessionStorage.clear();
                this.$store.reset();

                // Invalidate token
                this.$axios.post('/auth/logout');

                // Redirect user to login
                this.$router.push('/login')
            },
            updateShop(e) {

                // If user is editing an existing cash order, then redirect to cash order list
                if(this.$route.params.id !== 'new'){
                    this.$router.push('/cash-records');
                }

                this.$store.commit("SET_SHOP", e.target.value);
                this.$store.commit("SET_SHOP_NAME",e.target.options[e.target.options.selectedIndex].dataset.siteName);

                this.$setData('site_id',e.target.value);
                this.$setData('site_name',e.target.options[e.target.options.selectedIndex].dataset.siteName);

                const id = this.$getData('user_id',true);
                const shop = e.target.value;

                this.$axios.get(`/auth/permissions/${id}/${shop}`)
                    .then(resp => {
                        this.$store.commit("SET_PERMISSIONS", resp.data);
                        this.$setPermissions(resp.data);
                        return this.$axios.get(`/auth/permissions/${id}/${shop}/menu`);
                    })
                    .then(resp => {
                        this.$setMenu(resp.data);
                        this.$store.commit("SET_MENU", resp.data);
                    })
                    .catch(err => {
                        this.error = this.$getError(err);
                    });
            },
            toggleSidebar() {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false);
                }
            },
            toggleNavGroup(key) {
                const index = this.selected.indexOf(`collapse-${key}`);
                if (index === -1) {
                    this.selected.push(`collapse-${key}`);
                } else {
                    this.$delete(this.selected, index);
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
  .dropdown-menu {
    left: -50 !important;
  }
  .nav-link {
    cursor: pointer !important;
  }
  .nav-padding .nav-link {
    padding-left: 3rem !important;
  }
  .nav-item.select {
    padding: 0.65rem 1.5rem;
  }
  /* Sets the containers height and width */
  .base-timer {
    position: relative;
    width: 300px;
    height: 300px;
    &__circle {
      fill: none;
      stroke: none;
    }
    &__path-elapsed {
      stroke-width: 7px;
      stroke:grey;
    }
    &__label {
      position: absolute;
      width: 300px;
      height: 300px;
      top: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 48px;
    }
  }
</style>
